<crowdctrl-page [pageTitle]="pageTitle" defaultHref="/">
  <app-workspace-info [showInfoCard]="false"></app-workspace-info>
  <app-session-info [showInfoCard]="false"></app-session-info>
  @if (showPwaUpdateCard === true) {
    <ion-card>
      <ion-card-header>
        <ion-card-title>Version & Updates</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <crowdctrl-app-update [version]="version"></crowdctrl-app-update>
      </ion-card-content>
    </ion-card>
  }

  @if (showPwaUpdateCard === false) {
    <ion-card>
      <ion-card-header>
        <ion-card-title>App version</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p class="version-build">
          Build <strong>{{ version }}</strong>
        </p>
      </ion-card-content>
    </ion-card>
  }

  <ion-card>
    <ion-card-header>
      <ion-card-title>Display</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-item lines="none">
        <ion-label>
          <h3>Show Breadcrumbs</h3>
          <p>Display breadcrumb navigation on workspace pages</p>
        </ion-label>
        <ion-toggle
          slot="end"
          [checked]="showBreadcrumbs"
          (ionChange)="onBreadcrumbsToggleChange($event)"
        ></ion-toggle>
      </ion-item>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Remote Config</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <crowdctrl-remote-config-reload></crowdctrl-remote-config-reload>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Storage</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <p>Clear all locally stored data. You may need to sign in again.</p>
      <ion-button fill="outline" color="warning" (click)="onClearLocalStorageClick()">
        Clear Local Storage
      </ion-button>
    </ion-card-content>
  </ion-card>

  <crowdctrl-list>
    <ion-item button detail lines="none" [routerLink]="['/settings/theme']">
      <ion-label>Theme</ion-label>
      <div slot="end" class="settings-theme-preview">
        <crowdctrl-theme-preview-item
          [themeName]="currentThemeName"
          [showModeLabel]="false"
          [compact]="true"
        ></crowdctrl-theme-preview-item>
      </div>
    </ion-item>
    <ion-item button detail lines="none" [routerLink]="['/settings/developer']">
      <ion-label>Developer Settings</ion-label>
    </ion-item>
  </crowdctrl-list>
</crowdctrl-page>
